exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:16%!important}.b-form-input-container{margin:4px 0 12px!important}.activeClass{display:none}.error{color:red}.md-dialog-container.HereDialog.md-theme-default,.md-dialog-container.md-active{z-index:9999999}.md-dialog-container.HereDialog.md-theme-default .md-dialog{width:50%;height:50%}.md-select-content{z-index:999999999}.marg-top{margin-top:0}.md-card .md-card-content:last-child{height:85vh}@media (min-width:320px) and (max-width:767px){.mobile-width{min-width:100%;display:inline-block}.md-card .md-card-content:last-child{height:auto!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4eae5650","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/maintenance/ResOfQuo/addResOfQuo.vue
// module id = 1591
// module chunks = 0